import React, { Component } from "react";
import GeoLogo from "../../image/geo_acad.png"
import { PiShareFat } from "react-icons/pi";
import { FaAngleDown } from "react-icons/fa6";
import { LiaEllipsisVSolid } from "react-icons/lia";

class SelectedHeader extends Component {
    render() {
        return (
            <header className="selected_head">
                <div className="head_cover">
                    <section className="head_contain">
                        <img src={GeoLogo} alt="logo icon"/>
                        <h2 className="course_title">Creating each selected course information to be posted here </h2>
                    </section>
                    <section className="head_contain">
                        <button>Your Progress <FaAngleDown /></button>
                        <button>Share <PiShareFat /></button>
                        <button><LiaEllipsisVSolid /></button>
                    </section>
                </div>
            </header>
        )
    }
}


export default SelectedHeader